import { useState } from "react";
import { getFrequentFlyerList } from "@apac/travelers";
import type { Traveler } from "@b2bportal/traveler-api";

enum FrequentFlyerFormFields {
  FrequentFlyerNumber = "frequentFlyerNumber",
  FrequentFlyerAirline = "frequentFlyerAirline",
}

export type FrequentFlyerFormContext = {
  [FrequentFlyerFormFields.FrequentFlyerNumber]: string;
  [FrequentFlyerFormFields.FrequentFlyerAirline]: string;
};

const frequentFlyerDetailsDefaultValues: FrequentFlyerFormContext = {
  [FrequentFlyerFormFields.FrequentFlyerNumber]: "",
  [FrequentFlyerFormFields.FrequentFlyerAirline]: "",
};

interface UseFrequentFlyerFormFieldsParams {
  traveler?: Traveler;
}

export const useFrequentFlyerFormFields = ({
  traveler,
}: UseFrequentFlyerFormFieldsParams) => {
  const [frequentFlyerList, setFrequentFlyerList] = useState(
    traveler?.airTravelerDetails?.frequentFlyerNumbers
      ? getFrequentFlyerList(traveler?.airTravelerDetails?.frequentFlyerNumbers)
      : []
  );

  const onFrequentFlyerSubmit = ({
    frequentFlyerProgram,
    frequentFlyerNumber,
  }: {
    frequentFlyerProgram: string;
    frequentFlyerNumber: string;
  }) => {
    setFrequentFlyerList([
      ...frequentFlyerList,
      {
        key: frequentFlyerProgram,
        value: frequentFlyerNumber,
        trackingId: frequentFlyerList.length,
      },
    ]);
  };

  const onRemoveFrequentFlyer = (trackingId: number) => {
    setFrequentFlyerList(
      frequentFlyerList.filter((item) => item.trackingId !== trackingId)
    );
  };

  const formFields = {
    [FrequentFlyerFormFields.FrequentFlyerNumber]: {
      required: false,
    },
    [FrequentFlyerFormFields.FrequentFlyerAirline]: {
      required: false,
    },
  };

  return {
    formFields,
    frequentFlyerDetailsDefaultValues,
    frequentFlyerList,
    onFrequentFlyerSubmit,
    onRemoveFrequentFlyer,
  };
};
